import { TEST_CHAIN_ID } from "./constants";


// TODO: Fix This interface. 

interface IAddresses {
  OLPX_AGGREGATOR_ADDRESS: string;
  OLPX_LIMIT_ORDER_ADDRESS: string;
  OLPX_OLYMPIANS_ADDRESS?: string;
  OLYMPEX_PAS_ADDRESS?: string;
  OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS?: string;
  OLPX_FEE_COLLECTOR_ADDRESS?: string;
  OLPX_PARTNERS_CLAIM_ADDRESS?: string;
}

interface IContractAddresses {
  [chainId: number]: IAddresses;
}

export const contractAddresses: IContractAddresses = {
  [TEST_CHAIN_ID]: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  1: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  10: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  25: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  40: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  56: {
    OLPX_AGGREGATOR_ADDRESS: "0x1a362443D22a481867e1a20C16711f14102D3CB3",
    OLPX_LIMIT_ORDER_ADDRESS: "0xA95ccc6f0A561206dd1D0260C1ceE279CB4245A2",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "0x1a362443D22a481867e1a20C16711f14102D3CB3",
    OLPX_FEE_COLLECTOR_ADDRESS: "0x2AD3c28Af2c4C202047e14b3377f108E264ccFEF",
  },
  137: {
    OLPX_AGGREGATOR_ADDRESS: "0xE63182a88a0f0c4f2A9092cD3A6732abDaefb5F6",
    OLPX_LIMIT_ORDER_ADDRESS: "0x081334c945B64d78312Ce11fF577e0be3da17A44",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "0xE63182a88a0f0c4f2A9092cD3A6732abDaefb5F6",
    OLPX_FEE_COLLECTOR_ADDRESS: "0x60097d6AC179fC00F8d2cA26A98193B7d087060d",
    OLPX_OLYMPIANS_ADDRESS: "0x6793324c0895a642B6D66a2f86C8e72aBf1f13e7",
    OLYMPEX_PAS_ADDRESS: "0xC9239965d74bC6CCf8bce57667Be1609b9aA62E5",
    OLPX_PARTNERS_CLAIM_ADDRESS: "0xE1Fc9792CB029A77C47087b452481e32E9461847",
  },
  250: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  42161: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  42220: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  43114: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  59144: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  8453: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  80002: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  1285: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  1313161554: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  1088: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  1101: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  100: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  204: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  169: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  534352: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  81457: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
  34443: {
    OLPX_AGGREGATOR_ADDRESS: "",
    OLPX_LIMIT_ORDER_ADDRESS: "",
    OLPX_CROSSCHAIN_AGGREGATOR_ADDRESS: "",
    OLPX_FEE_COLLECTOR_ADDRESS: "",
  },
};
